import React from 'react';
import { ValueOf } from '../../utilities/types';

import conflictFields, { ConflictFields } from '../../constants/conflictFields';

import FirstName from './fields/FirstName';
import CompanyName from './fields/CompanyName';
import LastName from './fields/LastName';
import OrganizationNumber from './fields/OrganizationNumber';
import Tin from './fields/Tin';
import City from './fields/City';
import Residence from './fields/Residence';
import Email from './fields/Email';
import PostalCode from './fields/PostalCode';
import Address from './fields/Address';
import Website from './fields/Website';
import PhoneNumber from './fields/PhoneNumber';
import Signatories from './fields/Signatories';
import LegalForm from './fields/LegalForm';
import BeneficialOwner from './fields/BeneficialOwner';
import IsFinancialInstitution from './fields/IsFinancialInstitution';
import Industry from './fields/Industry';
import Activities from './fields/Activities';
// import PersonalNumber from '../components/conflict/fields/PersonalNumber';
import BeneficialOwners from './fields/BeneficialOwners';
import AlternativeBeneficialOwners from './fields/AlternativeBeneficialOwners';
import OwnerStructure from './fields/OwnerStructure';
import Salary from './fields/Salary';
import Citizenship from './fields/Citizenship';
import EmploymentStatus from './fields/EmploymentStatus';
import SourceOfFunds from './fields/SourceOfFunds';
import Purpose from './fields/Purpose';
import Products from './fields/Products';
import TaxResidency from './fields/TaxResidency';
import Pep from './fields/Pep';
import TransactionMonitoringThresholdsForm from './fields/TransactionMonitoringThresholdsForm';
import Role from './fields/Role';
import StateOwned from './fields/StateOwned';
import ForecastedTurnover from './fields/ForecastedTurnover';
import PreviousTurnover from './fields/previousTurnover';
import ListedFinancialMarket from './fields/ListedFinancialMarket';
import DateOfBirth from './fields/DateOfBirth';
import SourceOfWealth from './fields/SourceOfWealth';
import OperationStartDate from './fields/OperationStartDate';
import MerchantCategoryCode from './fields/MerchantCategoryCode';

const conflictFieldsMap: Record<ConflictFields, React.ComponentType> = {
  [conflictFields.ACTIVITIES]: Activities,
  [conflictFields.ADDRESS]: Address,
  [conflictFields.ALTERNATIVE_BENEFICIAL_OWNERS]: AlternativeBeneficialOwners,
  [conflictFields.BENEFICIAL_OWNER]: BeneficialOwner,
  [conflictFields.BENEFICIAL_OWNERS]: BeneficialOwners,
  [conflictFields.CITIZENSHIP]: Citizenship,
  [conflictFields.CITY]: City,
  [conflictFields.COMPANY_NAME]: CompanyName,
  [conflictFields.DATE_OF_BIRTH]: DateOfBirth,
  [conflictFields.EMAIL]: Email,
  [conflictFields.EMPLOYMENT_STATUS]: EmploymentStatus,
  [conflictFields.FIRST_NAME]: FirstName,
  [conflictFields.FORECASTED_TURNOVER]: ForecastedTurnover,
  [conflictFields.INCOME]: Salary,
  [conflictFields.INDUSTRY]: Industry,
  [conflictFields.IS_FINANCIAL_INSTITUTION]: IsFinancialInstitution,
  [conflictFields.LAST_NAME]: LastName,
  [conflictFields.LEGAL_FORM]: LegalForm,
  [conflictFields.LISTED_FINANCIAL_MARKET]: ListedFinancialMarket,
  [conflictFields.MIDDLE_NAME]: () => null,
  [conflictFields.OPERATION_START_DATE]: OperationStartDate,
  [conflictFields.MERCHANT_CATEGORY_CODE]: MerchantCategoryCode,
  [conflictFields.OTHER_LEGAL_FORM]: () => null,
  [conflictFields.OWNER_STRUCTURE]: OwnerStructure,
  [conflictFields.PEP]: Pep,
  [conflictFields.PHONE_NUMBER]: PhoneNumber,
  [conflictFields.POSTAL_CODE]: PostalCode,
  [conflictFields.PREVIOUS_TURNOVER]: PreviousTurnover,
  [conflictFields.PRODUCTS]: Products,
  [conflictFields.PURPOSE]: Purpose,
  [conflictFields.REGISTRATION_NUMBER]: OrganizationNumber,
  [conflictFields.RESIDENCE]: Residence,
  [conflictFields.ROLE]: Role,
  [conflictFields.SIGNATORIES]: Signatories,
  [conflictFields.SOURCE_OF_FUNDS]: SourceOfFunds,
  [conflictFields.SOURCE_OF_WEALTH]: SourceOfWealth,
  [conflictFields.STATE_OWNED]: StateOwned,
  [conflictFields.TAX_RESIDENCY]: TaxResidency,
  [conflictFields.TIN]: Tin,
  [conflictFields.TRANSACTION_MONITORING_THRESHOLD]: TransactionMonitoringThresholdsForm,
  [conflictFields.WEBSITE]: Website,
  // [conflictFields.CONTROL_TYPE]: PrimitiveInput,
  // [conflictFields.DIRECT_CONTROL]: PrimitiveInput,
  // [conflictFields.FAMILY_CONTROL]: PrimitiveInput,
  // [conflictFields.PERSONAL_NUMBER]: PersonalNumber,
} as const;

export type ConflictFieldsMap = ValueOf<typeof conflictFieldsMap>;

export default conflictFieldsMap;
